'use strict';

const $ = require('jquery');

class FloatingHeader {

    constructor() {

        let $floatingHeader = $('.fixed-header');
        let $keyvisual = $('.keyvisual');

        if ($floatingHeader.length > 0 && $keyvisual.length > 0) {

            let keyvisualHeight = $keyvisual.height();

            App.Globals.$window.on('load scroll', function () {

                let windowTop = App.Globals.$window.scrollTop();

                if (windowTop + $floatingHeader.height() >= ($keyvisual.offset().top + keyvisualHeight)) {

                    App.Globals.$body.addClass('scrolled');

                } else {

                    App.Globals.$body.removeClass('scrolled');

                }

            });

        }

    }

}

module.exports = FloatingHeader;
